// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20erl","name":"styles_name__3Es46","phone":"styles_phone__3Zxaj"};